import { getCustomerFields, getCustomerFields2 } from "../../../../Services/fieldsServices";
import React from 'react';
import { useState, useEffect, useRef } from 'react';
import CheckboxElement from '../../../../Components/UiComponents/CheckboxElement'
import _, { isEmpty } from 'lodash';
import InputTextElement from '../../../../Components/UiComponents/InputTextElement'
import TextareaElement from '../../../../Components/UiComponents/TextareaElement';
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { getBranchUser } from '../../../../Services/userService';
import DataTable from '../../../../Components/UiComponents/DataTable';
import { get, getCustomerDetails } from "../../../../Services/clientService";
import { generateCPlan, goalClientComplete } from "../../../../Services/clientService";
import { MultiSelect } from 'primereact/multiselect';
import SingleSelectElement from "../../../../Components/UiComponents/SingleSelectElement";
import CalendarElement from "../../../../Components/UiComponents/CalendarElement";
import { Tooltip } from 'primereact/tooltip';
import MultiSelectElement from "../../../../Components/UiComponents/MultiSelectElement";
import { Dialog } from "primereact/dialog";
import { clearCompletedNotification } from "../../../../Services/notificationService";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Moment from "moment";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";

export default function StakeHolderPlan(props) {
    const [userDataOps, setUserDataOps] = useState();
    const [branch, setBranch] = useState(null);
    const [users, setUsers] = useState([]);
    const [filterUsers, setFilterUsers] = useState([]);
    const [clientPlan, setClientPlan] = useState([]);
    const [loading, setLoading] = useState(false);

    const [targetData, setTargetData] = useState(null);
    const [multiHeader, setMultiHeader] = useState([]);
    const [newArrayData, setNewArrayData] = useState([]);
    const [result, setResult] = useState([]);
    const [targetDate, setTargetDate] = useState(null);
    const [briefSummary, setBriefSummary] = useState("");

    const [selectedOne, setSelectedOne] = useState([]);
    const [selectedPerson, setSelectedPerson] = useState(null);
    const [selectedPersonResp, setSelectedPersonResp] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [completedChecked, setCompletedChecked] = useState(false);
    const [knownChecked1, setKnownChecked1] = useState(false);
    const [checkedData, setCheckedData] = useState({});
    const [checked, setChecked] = useState(false);
    const [deleteItems, setDeleteItems] = useState([]);
    const [goalData, setGoalData] = useState({});
    const navigate = useNavigate()
    const [isUserActionOwnerSameTarget, setIsUserActionOwnerSameTarget] = useState(false);
    const [clientInitiativesCompletedModal, setClientInitiativesCompletedModal] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const statusFilter = [{ _id: 1, label: "Completed", value: true }, { _id: 2, label: "Incomplete", value: false }];
    const [historicData, setHistoricData] = useState([])
    const [showVideo, setShowVideo] = useState(false);

    const toastRef = useRef();

    useEffect(() => {
        setResult((prevData) => ({
            ...prevData,
            client_plan: clientPlan,
            client_plan_section_new: newArrayData
        }));
    }, [clientPlan, newArrayData])

    useEffect(() => {
        props.getData(result)
    }, [result])

    const generateCPlans = async () => {
        try {
          setLoading(true); 
      
          // Attempt to generate the CPlan
          const response = generateCPlan(props.clientId, props.customerId);
        } catch (error) {
          // Handle errors during the API request
          toastRef.current.showToast({
            type: "error",
            message: "An error occurred while generating the CPlan. Please contact Admin.",
          });
        } finally {
          setLoading(false);
        }
      };
      

    const [option, setOption] = useState([
        { id: "", needs: "" },
    ]);

    const [optionObjective, setOptionObjective] = useState([
        { id: "", objectives: "" },
    ]);

    const [optionIssues, setOptionIssues] = useState([
        { id: "", issues: "" },
    ]);

    const [optionDocument, setOptionDocument] = useState([
        { id: "", location: "", reference: "" },
    ]);

    function generateRandomID() {
        const hexChars = '0123456789abcdef';
        let result = '';
        for (let i = 0; i < 24; i++) {
            result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
        }
        return result;
    }

    const addItem = () => {
        const newRow = {
            _id: generateRandomID(),
            needs: ""
        };
        setOption([...option, newRow]);
        setClientPlan(prevState => ({
            ...prevState,
            client_needs: [...prevState.client_needs, newRow]
        }));
    };

    const [selectedOption, setSelectedOption] = useState([]);
    const [selectedNeeds, setSelectedNeeds] = useState([]);
    const [selectedObjective, setSelectedObjective] = useState([]);
    const [selectedIssues, setSelectedIssues] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState([]);


    const handleDeleteOption = () => {
        const updatedOptions = clientPlan.client_needs.filter(
            (row) => !selectedNeeds.includes(row)
        );
        setOption(updatedOptions);
        setClientPlan((prevState) => ({ ...prevState, client_needs: updatedOptions }));
        setSelectedNeeds([]);
    };

    const handleDeleteObjective = () => {
        const updatedOptions = clientPlan.client_objectives.filter(
            (row) => !selectedObjective.includes(row)
        );
        setOptionObjective(updatedOptions);
        setClientPlan((prevState) => ({ ...prevState, client_objectives: updatedOptions }));
        setSelectedObjective([]);
    };

    const handleDeleteIssues = () => {
        const updatedOptions = clientPlan.client_key_issues.filter(
            (row) => !selectedIssues.includes(row)
        );
        setOptionIssues(updatedOptions);
        setClientPlan((prevState) => ({ ...prevState, client_key_issues: updatedOptions }));
        setSelectedIssues([]);
    };

    const handleDeleteDocument = () => {
        const updatedOptions = clientPlan.document_reference.filter(
            (row) => !selectedDocument.includes(row)
        );
        setOptionDocument(updatedOptions);
        setClientPlan((prevState) => ({ ...prevState, document_reference: updatedOptions }));
        setSelectedDocument([]);
    };

    const addItemClientObjective = () => {
        const newRow = {
            _id: generateRandomID(),
            objectives: ""
        };
        setOptionObjective([...optionObjective, newRow]);
        setClientPlan(prevState => ({
            ...prevState,
            client_objectives: [...prevState.client_objectives, newRow]
        }));
    };

    const addItemIssues = () => {
        const newRow = {
            _id: generateRandomID(),
            issues: ""
        };
        setOptionIssues([...optionIssues, newRow]);
        setClientPlan(prevState => ({
            ...prevState,
            client_key_issues: [...prevState.client_key_issues, newRow]
        }));
    };


    const addItemDocument = () => {
        const newRow = {
            _id: generateRandomID(),
            reference: "",
            location: ""

        };
        setOptionDocument([...optionDocument, newRow]);
        setClientPlan((prevState) => ({
            ...prevState,
            document_reference: [
                ...(Array.isArray(prevState.document_reference) ? prevState.document_reference : []),
                newRow,
            ],
        }));
    };

    const onTextChangeNeeds = (index, field) => (e) => {
        const newClientNeeds = [...clientPlan?.client_needs];
        if (newClientNeeds[index] !== undefined) {
            newClientNeeds[index].needs = e.target.value;
            setClientPlan({ ...clientPlan, client_needs: newClientNeeds });
        }
    };

    const onTextChangeObjectives = (index, field) => (e) => {
        const newObjectives = [...clientPlan?.client_objectives];
        if (newObjectives[index] !== undefined) {
            newObjectives[index].objectives = e.target.value;
            setClientPlan({ ...clientPlan, client_objectives: newObjectives });
        }
    };

    const onTextChangeIssues = (index, field) => (e) => {
        const newIssues = [...clientPlan?.client_key_issues];
        if (newIssues[index] !== undefined) {
            newIssues[index].issues = e.target.value;
            setClientPlan({ ...clientPlan, client_key_issues: newIssues });
        }
    };

    const onTextChangeDocumentName = (index, field) => (e) => {
        const newDocumentName = [...clientPlan?.document_reference];
        if (field === "refernce") {
            newDocumentName[index][field] = e.value;
        } else {
            newDocumentName[index][field] = e.target.value;
        }

        setClientPlan({ ...clientPlan, document_reference: newDocumentName });
    };

    const onTextChangeDocumentLocation = (index, field) => (e) => {
        const newDocumentName = [...clientPlan?.document_reference.location];
        if (newDocumentName[index] !== undefined) {
            newDocumentName[index].reference = e.target.value;
            setClientPlan({ ...clientPlan, document_reference: newDocumentName });
        }
    };

    const needsEditor = (row, index) => {
        return (
            <div className="flex align-items-center">
                <InputTextElement
                    className="dropdown-field-handle"
                    value={row.needs}
                    placeholder="Description"
                    onChange={onTextChangeNeeds(index?.rowIndex, "needs")}
                />
            </div>
        );
    };

    const objectivesEditor = (row, index) => {
        return (
            <div className="flex align-items-center">
                <InputTextElement
                    className="dropdown-field-handle"
                    value={row.objectives}
                    placeholder="Description"
                    onChange={onTextChangeObjectives(index?.rowIndex, "objectives")}
                />
            </div>
        );
    };

    const stakeholderEditor = (row, index) => {
        return (
            <div className="flex align-items-center">
                <InputTextElement
                    className="dropdown-field-handle"
                    value={row.issues}
                    placeholder="Description"
                    onChange={onTextChangeIssues(index?.rowIndex, "issues")}
                />
            </div>
        );
    };

    const documentReferenceNameEditor = (row, index) => {
        return (
            <div className="flex align-items-center">
                <InputTextElement
                    className="dropdown-field-handle"
                    value={row.reference}
                    placeholder="Description"
                    onChange={onTextChangeDocumentName(index?.rowIndex, "reference")}
                />
            </div>
        );
    };

    const documentReferenceLocationEditor = (row, index) => {
        return (
            <div className="flex align-items-center">
                <InputTextElement
                    className="dropdown-field-handle"
                    value={row.location}
                    placeholder="Description"
                    onChange={onTextChangeDocumentName(index?.rowIndex, "location")}
                />
            </div>
        );
    };

    const findObjectWithValue = (array, key, targetValue) => {
        // Function to find and return the object containing the target value
        for (let item of array) {
            if (Array.isArray(item.items)) {
                for (let subItem of item.items) {
                    if (subItem[key] === targetValue) {
                        return item;
                    }
                }
            }
        }
        return null;
    }

    const needsHeader = () => {
        return clientNeedsHeading
    }

    const objectivesHeader = () => {
        return clientObjectivesHeading
    }

    const stakeholderHeader = () => {
        return clientKeyIssuesHeading
    }

    const clientDocumentHeadName = () => {
        return clientDocumentHeadingName
    }

    const clientDocumentHeadLocation = () => {
        return clientDocumentHeadingLocation
    }

    
    const columns = [
        { field: "needs", header: needsHeader, body: needsEditor, headerClassName: "header-datatable", className: 'row-datatable' },
    ]


    const columns2 = [
        { field: "objectives", header: objectivesHeader, body: objectivesEditor, headerClassName: "header-datatable", className: 'row-datatable' },
    ]


    const columns3 = [
        { field: "issues", header: stakeholderHeader, body: stakeholderEditor, headerClassName: "header-datatable", className: 'row-datatable' },
    ]

    const columns4 = [
        { field: "location", header: clientDocumentHeadName, body: documentReferenceNameEditor, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '30%' } },
        { field: "reference", header: clientDocumentHeadLocation, body: documentReferenceLocationEditor, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '70%' } },
    ]


    const rowClickNeeds = async (data) => {
        setSelectedNeeds(data)
    };
    const rowClickObjectives = async (data) => {
        setSelectedObjective(data)
    };
    const rowClickIssues = async (data) => {
        setSelectedIssues(data)
    };
    const rowClickDocument = async (data) => {
        setSelectedDocument(data)
    };


    const [customerId, setCustomerId] = useState(null);
    const [userId, setUserId] = useState(null);
    const [customerData, setCustomerData] = useState(null);


    const clientPlanSection = _.find(props.clientPlanData.clientSectionsClientPlan, { section_name: "Client Plan" });
    const clientFieldsClientPlan = _.find(props.clientPlanData.clientFieldsClientPlan, { field_name: "Brief Summary of Clients High Level Strategy" })?.display_name;
    const clientFieldsClientPlanStatus = _.find(props.clientPlanData.clientFieldsClientPlan, { field_name: "Brief Summary of Clients High Level Strategy" })?.field_status;
    const clientNeedsHeading = _.find(props.clientPlanData.clientFieldsClientPlan, { field_name: "Client Needs" })?.display_name;
    const clientObjectivesHeading = _.find(props.clientPlanData.clientFieldsClientPlan, { field_name: "Client Objectives" })?.display_name;
    const clientKeyIssuesHeading = _.find(props.clientPlanData.clientFieldsClientPlan, { field_name: "Client Key Issues" })?.display_name;
    const clientDocumentHeading = _.find(props.clientPlanData.clientFieldsClientPlan, { field_name: "Document Reference" })?.display_name;
    const clientDocumentHeaders = _.find(props.clientPlanData.clientPlanTable, { table_name: "Document Reference" })?.headers;
    const clientDocumentHeadingName = _.find(clientDocumentHeaders, { header_name: "Name" })?.display_name;
    const clientDocumentHeadingLocation = _.find(clientDocumentHeaders, { header_name: "Location Reference" })?.display_name;



    const getCustomer = async () => {

        if (customerId !== null) {
            try {
                setLoading(true)
                const response = await getCustomerFields(customerId);
                
                if(response && response.data){
                    let data = response.data
                    setCustomerData(data?.tooltips?.client?.others)
                    setTargetData(data?.reference_data)
    
                    var target = []
                    for (var i = 0; i < data?.reference_data.length; i++) {
                        if (data?.reference_data[i].option_names === "Target") {
                            target = _.filter(data?.reference_data[i].option_choice, { status: 'active' })
                        }
                    }
    
                    if (target.length > 0) {
                        var multiHeaderData = []
                        var planLength = target.length;
                        for (var l = 0; l < planLength; l++) {
                            var strategies = _.filter(data?.reference_data, { display_name: target[l].label });
                            var sub_items = [];
                            if (strategies.length > 0) {
                                var resLength = strategies[0].option_choice.length;
                                if (resLength > 0) {
                                    for (var k = 0; k < resLength; k++) {
                                        sub_items.push(
                                            {
                                                "label": strategies[0].option_choice[k].label,
                                                "value": strategies[0].option_choice[k].label,
                                                'checked': false,
                                                'person_responsible': '',
                                                'target_date': '',
                                                'completed': false
                                            }
                                        )
                                    }
                                }
                            }
                            multiHeaderData.push(
                                {
                                    "label": strategies[0]?.display_name,
                                    "code": strategies[0]?._id,
                                    'checked': false,
                                    "items": sub_items
                                }
                            );
                        }
                        setMultiHeader(multiHeaderData)
                    }
                }
                

            } catch (error) {
                toastRef.current.showToast({
                    type: "error",
                    message: "Failed to fetch module permissions. Please try again or contact Admin.",
                  });
            } finally {
                setLoading(false)
            }
        }
    }
    const [clientKnownHeading, setClientKnownHeading] = useState("Known Stakeholder Initiatives")
    const getFunctionBasedOnObject = (obj) => {
        if (isEmpty(obj)) {
            return true;
        } else {
            return false;
        }
    };
    useEffect(() => {
        const isObjectEmpty = getFunctionBasedOnObject(props?.clientPlanData?.clientKnownHeading)
        if (!isObjectEmpty) {
            setClientKnownHeading(props?.clientPlanData?.clientKnownHeading)
        }

    }, [props?.clientPlanData?.clientKnownHeading])



    // const moveItemsUp = () => {
    //     setItems(prevItems => {
    //         const newItems = [...prevItems];
    //         selectedItems.forEach(item => {
    //             const index = newItems.indexOf(item);
    //             if (index > 0) {
    //                 [newItems[index - 1], newItems[index]] = [newItems[index], newItems[index - 1]];
    //             }
    //         });
    //         return newItems;
    //     });
    // };

    // const moveItemsDown = () => {
    //     setItems(prevItems => {
    //         const newItems = [...prevItems];
    //         selectedItems.reverse().forEach(item => {
    //             const index = newItems.indexOf(item);
    //             if (index < newItems.length - 1) {
    //                 [newItems[index + 1], newItems[index]] = [newItems[index], newItems[index + 1]];
    //             }
    //         });
    //         return newItems;
    //     });
    // };
    const [customerShort, setCustomerShort] = useState(null)

    const getCustomerData = async (id) =>{
		const customerData = await getCustomerDetails(id);
		if(customerData && customerData.data){
			setCustomerShort(customerData.data.customer_short)
		}
	}

    const [endUser, setEndUser] = useState(null)
    useEffect(() => {

        // Fetching end user data from local storage
        const enduserStr = localStorage.getItem("enduser");

        // Checking if end user data exists in local storage
        if (enduserStr) {
            // Parsing end user data
            const enduser = JSON.parse(enduserStr);
            setEndUser(enduser)

            // Extracting customer information from end user data
            const customer = enduser.customer;
            getCustomerData(customer)
            // Setting customer ID state
            setCustomerId(customer);

            const userId = enduser.userid;
            setUserId(userId);

            const branch = enduser.branch;
            // Setting customer ID state
            setBranch(branch);
        }else {
            navigate("/login")
            localStorage.clear()
          }

        getCustomer();
    }, [customerId])

    useEffect(() => {
        getBranchUsers();
    }, [multiHeader])

    const convertDateStringToFormattedString = (dateString) => {
        if (dateString != '') {
            const [day, month, year] = dateString?.split('-').map(Number);
            return new Date(year, month - 1, day);
        }
    };

    const getBranchUsers = async () => {
        try{
            setLoading(true)
        if (customerId && branch) {
            
            const res = await getBranchUser(customerId, branch.branch_id);
            if(res && res.data){
            
            var userData = res.data;
            setUsers(userData);
            for (var i = 0; i < userData.length; i++) {
                userData[i].label = userData[i].firstname + " " + userData[i].surname;
            }
            setFilterUsers(_.cloneDeep(userData));
            const userResponsible = userData.map(user => ({
                label: `${user.firstname} ${user.surname}`,
                // value: `${user.firstname} ${user.surname}`,
                _id: user._id
            }))
            setUserDataOps(userResponsible)
            if (props) {
                const res = await get(props.clientId, props.customerId, branch);
                if(res && res.data){
                    setResult(res.data.client[0])
                    const optionFromDatabase = res?.data?.client[0]?.client_plan_section_new.map(section => ({
                        ...section,
                        strategic_initiative: section.strategic_initiative.map(initiative => {
                            const responsibleUser = userResponsible?.find(user => user._id === initiative.person_responsible);
                            return {
                                ...initiative,
                                person_responsible: responsibleUser ? responsibleUser : '',
                                target_date: initiative.target_date != null ? initiative.target_date : ''
                            };
                        })
                    }));
                    const multiHeaderLabels = multiHeader.flatMap(header => header.items.map(item => item.label));
                    const selectedOneData = optionFromDatabase.flatMap(section =>
                        section.strategic_initiative
                            .filter(initiative => multiHeaderLabels.includes(initiative.strategic_initiative_name))
                            .map(initiative => initiative.strategic_initiative_name)
                    );
                    setSelectedOne(selectedOneData)
                    setNewArrayData(optionFromDatabase)
                    setHistoricData(optionFromDatabase)
                    setUsers(res.data);
                    const clientNeeds = res.data.client[0].client_plan;
                    setClientPlan(clientNeeds)
                }
            }
        }
        }
    } catch (error){
        toastRef.current.showToast({
            type: "error",
            message: "Failed to fetch Branch User. Please try again or contact Admin.",
          });
    } finally {
        setLoading(false)
    }
    }

    const [multiSelectedOption, setMultiSelectedOption] = useState([]);
    const [sectionNameToDelete, setSectionNameToDelete] = useState([])
    const onChangeMulti1 = (e) => {
        setMultiSelectedOption(e.value);

        // Prepare new data based on the selected options
        var newData = [];
        for (let v of e.value) {
            const foundObject = findObjectWithValue(multiHeader, 'value', v);
            if (foundObject) {
                const filteredItems = foundObject.items.filter(item => item.value === v);
                const newObject = {
                    ...foundObject,
                    items: filteredItems
                };
                newData.push(newObject);
            }
        }


        const groupedData = newData.reduce((acc, section) => {
            const existingSection = acc.find(item => item.strategies === section.label);
            if (existingSection) {
                existingSection.strategic_initiative = [
                    ...existingSection.strategic_initiative,
                    ...section.items.map(item => {
                        const responsibleUser = userDataOps.find(user => user._id === `${item.person_responsible}`);
                        return {
                            label: item.value,
                            value: item.value,
                            initiative_description: item.initiative_description || '',
                            person_responsible: responsibleUser || '',
                            strategic_initiative_name: item.label,
                            target_date: item.target_date || '',
                            isCompleted: item.completed
                        };
                    })
                ];
            } else {
                acc.push({
                    strategies: section.label,
                    strategic_initiative: section.items.map(item => {
                        const responsibleUser = userDataOps.find(user => user._id === `${item.person_responsible}`);
                        return {
                            label: item.value,
                            value: item.value,
                            initiative_description: item.initiative_description || '',
                            person_responsible: responsibleUser || '',
                            strategic_initiative_name: item.label,
                            target_date: item.target_date || '',
                            isCompleted: item.completed
                        };
                    })
                });
            }
            return acc;
        }, []);

        setNewArrayData((prevData) => {
            const updatedDataMap = new Map(prevData.map(section => [section.strategies, section]));

            groupedData.forEach((newSection) => {
                if (updatedDataMap.has(newSection.strategies)) {
                    const existingSection = updatedDataMap.get(newSection.strategies);
                    const existingItems = new Set(existingSection.strategic_initiative.map(item => item.strategic_initiative_name));

                    newSection.strategic_initiative = newSection.strategic_initiative.filter(item => {
                        if (existingItems.has(item.value)) {
                            const existingItem = existingSection.strategic_initiative.find(ei => ei.value === item.value);
                            if (existingItem) {
                                Object.assign(existingItem, item);
                            }
                            return false;
                        }
                        return true;
                    });

                    updatedDataMap.set(newSection.strategies, {
                        ...existingSection,
                        strategic_initiative: [...existingSection.strategic_initiative, ...newSection.strategic_initiative],
                    });
                } else {
                    updatedDataMap.set(newSection.strategies, newSection);
                }
            });

            // Remove unchecked items from the newArrayData
            const selectedValues = new Set(e.value);
            for (const [key, section] of updatedDataMap) {
                section.strategic_initiative = section.strategic_initiative.filter(item => selectedValues.has(item.value));
                if (section.strategic_initiative.length === 0) {
                    updatedDataMap.delete(key);
                }
            }

            return Array.from(updatedDataMap.values());
        });

        setHistoricData((prevData) => {
            const updatedDataMap = new Map(prevData.map(section => [section.strategies, section]));

            groupedData.forEach((newSection) => {
                if (updatedDataMap.has(newSection.strategies)) {
                    const existingSection = updatedDataMap.get(newSection.strategies);
                    const existingItems = new Set(existingSection.strategic_initiative.map(item => item.strategic_initiative_name));

                    newSection.strategic_initiative = newSection.strategic_initiative.filter(item => {
                        if (existingItems.has(item.value)) {
                            const existingItem = existingSection.strategic_initiative.find(ei => ei.value === item.value);
                            if (existingItem) {
                                Object.assign(existingItem, item);
                            }
                            return false;
                        }
                        return true;
                    });

                    updatedDataMap.set(newSection.strategies, {
                        ...existingSection,
                        strategic_initiative: [...existingSection.strategic_initiative, ...newSection.strategic_initiative],
                    });
                } else {
                    updatedDataMap.set(newSection.strategies, newSection);
                }
            });

            // Remove unchecked items from the newArrayData
            const selectedValues = new Set(e.value);
            for (const [key, section] of updatedDataMap) {
                section.strategic_initiative = section.strategic_initiative.filter(item => selectedValues.has(item.value));
                if (section.strategic_initiative.length === 0) {
                    updatedDataMap.delete(key);
                }
            }

            return Array.from(updatedDataMap.values());
        });

        setSelectedOne(e.value);
    };

    const onChangeMulti = (e) => {
        setMultiSelectedOption(e.value)
        const selectedValues = e.value;
        var newData = [];
        for (let v of e.value) {
            const foundObject = findObjectWithValue(multiHeader, 'value', v);
            if (foundObject) {
                const filteredItems = foundObject.items.filter(item => item.value === v);
                const newObject = {
                    ...foundObject,
                    items: filteredItems
                };
                newData.push(newObject);
            }
        }

        const groupedData = newData.reduce((acc, section) => {
            const existingSection = acc.find(item => item.strategies === section.label);
            if (existingSection) {
                existingSection.strategic_initiative = [
                    ...existingSection.strategic_initiative,
                    ...section.items.map(item => {
                        const responsibleUser = userDataOps.find(user => user._id === `${item.person_responsible}`);
                        return {
                            label: item.value,
                            value: item.value,
                            initiative_description: item.initiative_description || '',
                            person_responsible: responsibleUser || '',
                            strategic_initiative_name: item.label,
                            target_date: item.target_date || '',
                            isCompleted: item.completed
                        };
                    })
                ];
            } else {
                acc.push({
                    strategies: section.label,
                    strategic_initiative: section.items.map(item => {
                        const responsibleUser = userDataOps.find(user => user._id === `${item.person_responsible}`);
                        return {
                            label: item.value,
                            value: item.value,
                            initiative_description: item.initiative_description || '',
                            person_responsible: responsibleUser || '',
                            strategic_initiative_name: item.label,
                            target_date: item.target_date || '',
                            isCompleted: item.completed
                        };
                    })
                });
            }
            return acc;
        }, []);

        setNewArrayData((prevData) => {
            const updatedDataMap = new Map(prevData.map(section => [section.strategies, section]));

            groupedData.forEach((newSection) => {
                if (updatedDataMap.has(newSection.strategies)) {
                    const existingSection = updatedDataMap.get(newSection.strategies);
                    const existingItems = new Set(existingSection.strategic_initiative.map(item => item.strategic_initiative_name));

                    newSection.strategic_initiative = newSection.strategic_initiative.filter(item => {
                        if (existingItems.has(item.value)) {
                            const existingItem = existingSection.strategic_initiative.find(ei => ei.value === item.value);
                            if (existingItem) {
                                Object.assign(existingItem, item);
                            }
                            return false;
                        }
                        return true;
                    });

                    updatedDataMap.set(newSection.strategies, {
                        ...existingSection,
                        strategic_initiative: [...existingSection.strategic_initiative, ...newSection.strategic_initiative],
                    });
                } else {
                    updatedDataMap.set(newSection.strategies, newSection);
                }
            });

            return Array.from(updatedDataMap.values());
        });
        setHistoricData((prevData) => {
            const updatedDataMap = new Map(prevData.map(section => [section.strategies, section]));

            groupedData.forEach((newSection) => {
                if (updatedDataMap.has(newSection.strategies)) {
                    const existingSection = updatedDataMap.get(newSection.strategies);
                    const existingItems = new Set(existingSection.strategic_initiative.map(item => item.strategic_initiative_name));

                    newSection.strategic_initiative = newSection.strategic_initiative.filter(item => {
                        if (existingItems.has(item.value)) {
                            const existingItem = existingSection.strategic_initiative.find(ei => ei.value === item.value);
                            if (existingItem) {
                                Object.assign(existingItem, item);
                            }
                            return false;
                        }
                        return true;
                    });

                    updatedDataMap.set(newSection.strategies, {
                        ...existingSection,
                        strategic_initiative: [...existingSection.strategic_initiative, ...newSection.strategic_initiative],
                    });
                } else {
                    updatedDataMap.set(newSection.strategies, newSection);
                }
            });

            return Array.from(updatedDataMap.values());
        });
        var data = e.value.includes(e.selectedOption.label)
        if (!data) {
            setDeleteItems([e.selectedOption.label])
            removeSelected([e.selectedOption.label])
        }
        // setSelectedOne(e.value);
        setSelectedOne(prevNames => [...new Set([...prevNames, ...selectedValues])]);
    };

    const addNewStrategy = () => {
        if (sectionNameToDelete.length > 0) {
            const updatedData = newArrayData.map((item) => {
                if (sectionNameToDelete.includes(item.strategies)) {
                    return {
                        ...item,
                        strategic_initiative: [
                            ...item.strategic_initiative,
                            {
                                label: "New Initiative",
                                value: "New Initiative",
                                initiative_description: "",
                                person_responsible: "",
                                strategic_initiative_name: "New Initiative",
                                target_date: "",
                                isChecked: false,
                            },
                        ],
                    };
                }
                return item;
            });
    
            setNewArrayData(updatedData);
            setHistoricData(updatedData);
        } else {
            const new_data = {
                strategies: `New Initiative Section ${newArrayData.length === 0 ? "" : newArrayData.length}`,
                strategic_initiative: [
                    {
                        label: "New Initiative",
                        value: "New Initiative",
                        initiative_description: "",
                        person_responsible: "",
                        strategic_initiative_name: "New Initiative",
                        target_date: "",
                        isChecked: false,
                    },
                ],
            };
            setNewArrayData((prevData) => [...prevData, new_data]);
            setHistoricData((prevData) => [...prevData, new_data]);
        }
    };

    const removeSelected = (value) => {
        // If section names need to be deleted
        if (sectionNameToDelete.length > 0) {
            setNewArrayData((prevData) => {
                const updatedData = _.filter(prevData, (section) => !_.includes(sectionNameToDelete, section.strategies));
                return updatedData;
            });
            setHistoricData((prevData) => {
                const updatedData = _.filter(prevData, (section) => !_.includes(sectionNameToDelete, section.strategies));
                return updatedData;
            });
            setSectionNameToDelete([]);
        }
        // If individual initiatives need to be deleted
        else if (deleteItems.length > 0) {
            const updatedData = _.map(newArrayData, (section) => {
                const filteredInitiatives = _.filter(section.strategic_initiative, (initiative) =>
                    !_.includes(deleteItems, initiative.strategic_initiative_name)
                );
                return {
                    ...section,
                    strategic_initiative: filteredInitiatives
                };
            });

            const cleanedArray = updatedData.filter(obj => {
                return obj.strategic_initiative.length > 0;
            });
            setNewArrayData(cleanedArray);
            setHistoricData(cleanedArray);

            // Update selectedOne based on the filtered data
            const multiHeaderLabels = _.flatMap(multiHeader, (header) => _.map(header.items, 'label'));
            const selectedOneData = _.flatMap(cleanedArray, (section) =>
                _.map(
                    _.filter(section.strategic_initiative, (initiative) =>
                        _.includes(multiHeaderLabels, initiative.strategic_initiative_name)
                    ),
                    'strategic_initiative_name'
                )
            );

            setSelectedOne(selectedOneData);
            setDeleteItems([]);
        }
        else if (value.length > 0) {
            const updatedData = _.map(newArrayData, (section) => {
                const filteredInitiatives = _.filter(section.strategic_initiative, (initiative) =>
                    !_.includes(value, initiative.strategic_initiative_name)
                );
                return {
                    ...section,
                    strategic_initiative: filteredInitiatives
                };
            });

            const cleanedArray = updatedData.filter(obj => {
                return obj.strategic_initiative.length > 0;
            });
            setNewArrayData(cleanedArray);
            setHistoricData(cleanedArray);

            // Update selectedOne based on the filtered data
            const multiHeaderLabels = _.flatMap(multiHeader, (header) => _.map(header.items, 'label'));
            const selectedOneData = _.flatMap(cleanedArray, (section) =>
                _.map(
                    _.filter(section.strategic_initiative, (initiative) =>
                        _.includes(multiHeaderLabels, initiative.strategic_initiative_name)
                    ),
                    'strategic_initiative_name'
                )
            );

            setSelectedOne(selectedOneData);
            setDeleteItems([]);
        }
        else if (value.length > 0) {
            const updatedData = _.map(newArrayData, (section) => {
                const filteredInitiatives = _.filter(section.strategic_initiative, (initiative) =>
                    !_.includes(value, initiative.strategic_initiative_name)
                );
                return {
                    ...section,
                    strategic_initiative: filteredInitiatives
                };
            });

            const cleanedArray = updatedData.filter(obj => {
                return obj.strategic_initiative.length > 0;
            });
            setNewArrayData(cleanedArray);
            setHistoricData(cleanedArray);

            // Update selectedOne based on the filtered data
            const multiHeaderLabels = _.flatMap(multiHeader, (header) => _.map(header.items, 'label'));
            const selectedOneData = _.flatMap(cleanedArray, (section) =>
                _.map(
                    _.filter(section.strategic_initiative, (initiative) =>
                        _.includes(multiHeaderLabels, initiative.strategic_initiative_name)
                    ),
                    'strategic_initiative_name'
                )
            );

            setSelectedOne(selectedOneData);
            setDeleteItems([]);
        }
    };


    const handleCheckboxChange = (item, index, label) => {
        if (item.target.checked) {
            setSectionNameToDelete((prevData) => {
                return [...prevData, label];
            });
        } else {
            setSectionNameToDelete((prevData) => {
                return prevData.filter((name) => name !== label);
            });
        }

    };

    const groupedItemTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <div>{option.label}</div>
            </div>
        );
    };
    const handleSelectedSubStretigies = (checked, item, strategy) => {
        if (checked) {
            setDeleteItems((prevData) => {
                return [...prevData, item.strategic_initiative_name];
            })
            setChecked(checked)
            setCheckedData({
                name: item.strategic_initiative_name,
                strategy: strategy,
                initiative_description: item.initiative_description
            })
        } else {
            setDeleteItems((prevData) => {
                return prevData.filter((name) => name !== item.strategic_initiative_name);
            });
            setChecked(checked)
        }
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown)
    }

    const resetButton = () => {
        setSelectedPersonResp([])
        setSelectedStatus([])
        getBranchUsers()
    }
    const filterClientData = (selectedPerson) => {
        const filterLabels = _.map(selectedPerson, 'label');

        // Flatten items arrays, filter, and then group back by groupId
        const filteredMainArray = _.map(historicData, group => {
            const filteredItems = _.filter(group.strategic_initiative, item => _.includes(filterLabels, item.person_responsible.label));
            return {
                ...group,
                strategic_initiative: filteredItems
            };
        });

        const cleanedArray = filteredMainArray.filter(obj => {
            return obj.strategic_initiative.length > 0;
        });
        setNewArrayData(cleanedArray);

        return cleanedArray
    };


    const filterStatusData = (completed) => {
        const result = newArrayData?.map(item => {
            const filteredInitiatives = item.strategic_initiative.filter(initiative => {
                for (let id of completed) {
                    if (initiative.isCompleted === id) {
                        return true
                    }
                }
            });
            if (filteredInitiatives.length > 0) {
                return {
                    ...item,
                    strategic_initiative: filteredInitiatives
                };
            }
            return null;
        }).filter(item => item !== null);

        setNewArrayData(result);

        return result
    };

    const handleSelection = (event) => {
        if (event.length > 0) {
            setSelectedPersonResp(event);
            var newData = filterClientData(event)
        } else {
            setSelectedPersonResp([])
            getBranchUsers()
        }
    }

    const handleStatusSelection = (event) => {
        if (event.length > 0) {
            setSelectedStatus(event);
            var newData = filterStatusData(event)
        } else {
            setSelectedStatus([])
            getBranchUsers()
        }
    }

    const reorderClick = (data) => {
        setClientPlan(prevState => ({
            ...prevState,
            client_needs: data
        }));
    }

    const reorderClick1 = (data) => {
        setClientPlan(prevState => ({
            ...prevState,
            client_objectives: data
        }));
    }

    const reorderClick2 = (data) => {
        setClientPlan(prevState => ({
            ...prevState,
            client_key_issues: data
        }));
    }

    const reorderClick3 = (data) => {
        setClientPlan(prevState => ({
            ...prevState,
            document_reference: data
        }));
    }

    const handleTextArea = (e) => {
        setClientPlan(prevState => ({
            ...prevState,
            initiative_description: e.target.value
        }))
    }

    const handleCompleted = (e, ind, index, strategies, item) => {
        setCompletedChecked(e.target.checked)

        if (e.target.checked) {
            var goalData = {};
            goalData = {
                parentIndex: ind,
                index: index,
                strategies: strategies,
                target: item.strategic_initiative_name,
                status: item.isCompleted
            }
            // let newArrayDataCopy = newArrayData
            // newArrayDataCopy[goalData.parentIndex].strategic_initiative[goalData.index].isCompleted = e.target.checked;
            // setNewArrayData(newArrayDataCopy)
            setNewArrayData((prevData) => 
                prevData.map((strategy, parentIndex) =>
                  parentIndex === goalData.parentIndex
                    ? {
                        ...strategy,
                        strategic_initiative: strategy.strategic_initiative.map(
                          (initiative, index) =>
                            index === goalData.index
                              ? { ...initiative, isCompleted: e.target.checked }
                              : initiative
                        ),
                      }
                    : strategy
                )
              );
              setHistoricData((prevData) => 
                prevData.map((strategy, parentIndex) =>
                  parentIndex === goalData.parentIndex
                    ? {
                        ...strategy,
                        strategic_initiative: strategy.strategic_initiative.map(
                          (initiative, index) =>
                            index === goalData.index
                              ? { ...initiative, isCompleted: e.target.checked }
                              : initiative
                        ),
                      }
                    : strategy
                )
              );
              
           
              
            // setHistoricData(newArrayDataCopy)
            setGoalData(goalData)
            if (item._id != undefined) {
                if (userId == newArrayData[ind].strategic_initiative[index].person_responsible._id) {
                    setIsUserActionOwnerSameTarget(true);
                    setClientInitiativesCompletedModal(true)
                } else {
                    setIsUserActionOwnerSameTarget(false);
                    setClientInitiativesCompletedModal(true)
                }
            }
            else {
                toastRef.current.showToast({
                    type: 'error',
                    message: "Please save the task"
                });
                goalData = {
                    parentIndex: ind,
                    index: index,
                    strategies: strategies,
                    target: item.strategic_initiative_name,
                    status: item.isCompleted
                }
                setNewArrayData((prevData) => 
                    prevData.map((strategy, parentIndex) =>
                      parentIndex === goalData.parentIndex
                        ? {
                            ...strategy,
                            strategic_initiative: strategy.strategic_initiative.map(
                              (initiative, index) =>
                                index === goalData.index
                                  ? { ...initiative, isCompleted: false }
                                  : initiative
                            ),
                          }
                        : strategy
                    )
                  );
                  setHistoricData((prevData) => 
                    prevData.map((strategy, parentIndex) =>
                      parentIndex === goalData.parentIndex
                        ? {
                            ...strategy,
                            strategic_initiative: strategy.strategic_initiative.map(
                              (initiative, index) =>
                                index === goalData.index
                                  ? { ...initiative, isCompleted: false }
                                  : initiative
                            ),
                          }
                        : strategy
                    )
                  );
                  
                 
            }
        }
    }

    const closeClientCompleted = () => {
        var parentIndex = goalData.parentIndex;
        var index = goalData.index;
        newArrayData[parentIndex].strategic_initiative[index].isCompleted = false;
        setNewArrayData(newArrayData)
        setHistoricData(newArrayData)
        setClientInitiativesCompletedModal(false)
    }

    const modalClientCompleted = async () => {
        try {
          setLoading(true); 
      
          const parentIndex = goalData.parentIndex;
          const index = goalData.index;
            
          const tmpGoalData = _.cloneDeep(newArrayData[parentIndex].strategic_initiative[index]._id);
      
          // Make the API call to complete the client goal
          const result = await goalClientComplete(props.clientId, props.customerId, parentIndex, index);
      
          // Handle success or failure of goalClientComplete API
          if (result && result.data && result.data.success) {
            // Clear the completed notification if the goal is successfully marked as completed
            const res = await clearCompletedNotification(tmpGoalData);
      
            if (res && res.data && res.data.success) {
              newArrayData[parentIndex].strategic_initiative[index].isCompleted = true;
              setNewArrayData([...newArrayData]); 
              setHistoricData([...newArrayData]); 
      
              toastRef.current.showToast({
                type: 'success',
                message: result.data.message
              });
              setClientInitiativesCompletedModal(false); 
            }
          } else {
            // Handle failure in goalClientComplete
            toastRef.current.showToast({
              type: 'error',
              message: result?.data?.message || 'Failed to complete the client goal.'
            });
          }
        } catch (error) {
          // Catch and handle any unexpected errors
          toastRef.current.showToast({
            type: 'error',
            message: 'An error occurred. Please try again or contact Admin.'
          });
        } finally {
          setLoading(false);
        }
      };
      

    const headerTemplate = () => {
        return 'Client Initiatives : ' + goalData.strategies + ' - ' + goalData.target
    }

    const renderFooter = () => {
        return (
            <div className="cancel-footer">
                <div className="align-center justify-end pb-0">
                    {
                        isUserActionOwnerSameTarget ?
                            <>
                                <ButtonElement label="No" className="cancel-new-button" onClick={() => closeClientCompleted()} />
                                <ButtonElement type="submit" label="Yes" className="save-button" onClick={() => modalClientCompleted()} />
                            </>
                            :
                            <ButtonElement type="submit" label="Close" className="save-button" onClick={() => closeClientCompleted()} />
                    }
                </div>
            </div>
        );
    };

    const handleBrief = (e) => {
        setClientPlan(prevState => ({
            ...prevState,
            overal_client_strategy: e.target.value
        }))
    }

    const handlePerson = (e, ind, index) => {

        setSelectedPerson(e.value)
        newArrayData[ind].strategic_initiative[index].person_responsible = e.value

        setNewArrayData(newArrayData)
        setHistoricData(newArrayData)
    }
    const handleTextInitiativesName = (e, strategy, name) => {
        // Find the index of the strategy
        const ind = newArrayData.findIndex((item) => item.strategies === strategy);

        if (ind !== -1) {
            // Find the index of the initiative within the strategy
            const index = newArrayData[ind].strategic_initiative.findIndex((item) => item.strategic_initiative_name === name);

            if (index !== -1) {
                // Create a copy of newArrayData
                const updatedArrayData = [...newArrayData];

                // Update the initiative description
                updatedArrayData[ind].strategic_initiative[index].initiative_description = e.target.value;

                // Update the state with the new array
                setNewArrayData(updatedArrayData);
                setHistoricData(updatedArrayData);
            }
        }
    };


    const handleDate = (e, ind, index) => {
        setTargetDate(e.value)
        newArrayData[ind].strategic_initiative[index].target_date = Moment(e.value).format("DD-MM-YYYY")
        setNewArrayData(newArrayData)
        setHistoricData(newArrayData)
    }

    const handleInputChange = (e, ind, index) => {
        newArrayData[ind].strategies = e.target.value
        setNewArrayData(newArrayData)
        setHistoricData(newArrayData)
    }

    const handleInputChangeName = (e, ind, index) => {
        // Create a copy of the array
        const updatedArrayData = [...newArrayData];

        // Make the necessary update
        updatedArrayData[ind].strategic_initiative[index].strategic_initiative_name = e.target.value;

        // Update the state with the new array
        setNewArrayData(updatedArrayData);
        setHistoricData(updatedArrayData);
    };


    const dropdownRef = useRef(null);
    const handleOutsideClick = (event) => {
        if (showDropdown) {
            const target = event.target;
            const dropdownButton = document.querySelector('.clear-filter-button');
            const dropdownContent = document.querySelector('.s-field');
            const multiSelectInput = document.querySelector('.p-multiselect-filter');

    
            // Check if the clicked element is not in the dropdown, the button, or any MultiSelect/single select items
            if (
                !dropdownContent.contains(target) && 
                target !== dropdownButton && 
                target !== multiSelectInput &&
                !target.closest('.p-multiselect-item') && // MultiSelect items
                !target.closest('.p-dropdown-item') // Single select dropdown items
            ) {
                setShowDropdown(false);
            }
        }
    };
    
    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [showDropdown]);

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="col-md-12 text-right">
				<ButtonElement className="upload-button mb-2" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
			</div>
            <div className="new-field d-flex">
                {
                    clientFieldsClientPlanStatus &&
                    <div className="col-md-6 pl-0 box-border-plan">
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className='col pr-0'>
                                <div className="d-flex">
                                    <label className="form-label text-left">{clientFieldsClientPlan}:</label>
                                    {
                                        customerData?.Stakeholder_plan?.brief_summary_of_clients_high_level_strategy.status == true &&
                                        <div className="ml-10">
                                            <Tooltip target=".custom-target-icon" />

                                            <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                                data-pr-tooltip={customerData?.Stakeholder_plan?.brief_summary_of_clients_high_level_strategy.text}
                                                data-pr-position="right">
                                            </i>
                                        </div>
                                    }
                                </div>
                                <TextareaElement
                                    name="brief"
                                    defaultValue={clientPlan.overal_client_strategy}
                                    rows={4}
                                    cols={30}
                                    placeholder="Enter text here..."
                                    className="w-full"
                                    onChange={(e) => handleBrief(e)}
                                />
                            </div>
                        </div>
                    </div>
                }
                {
                    _.find(props.clientPlanData.clientPlanTable, { table_name: "Client Needs" })?.status &&
                    <div className="col-md-6 pl-0 box-border-plan ml-10">
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col pr-0 pt-0">
                                <div className="form-group row align-items-center mb-0">
                                    <div className="col-md-4 pl-0">
                                        {/* <p className="form-label text-left">
                                    </p> */}
                                    </div>
                                    <div className="col pr-0 d-flex justify-end">
                                        <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteOption} />
                                        <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItem} />
                                    </div>
                                </div>
                                <DataTable
                                    value={clientPlan.client_needs}
                                    columns={columns}
                                    dataKey="_id"
                                    isCheckbox={true}
                                    rowClick={rowClickNeeds}
                                    reorderClick={reorderClick}
                                />
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div className="new-field d-flex mt-20">
                {
                    _.find(props.clientPlanData.clientPlanTable, { table_name: "Client Objectives" })?.status &&
                    <div className="col-md-6 pl-0 box-border-plan">
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col pr-0">
                                <div className="form-group row align-items-center mb-0">
                                    <div className="col-md-4 pl-0">
                                        {/* <p className="form-label text-left">
                                    </p> */}
                                    </div>
                                    <div className="col pr-0 d-flex justify-end">
                                        <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteObjective} />
                                        <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemClientObjective} />
                                    </div>
                                </div>
                                <DataTable
                                    value={clientPlan.client_objectives}
                                    columns={columns2}
                                    dataKey="_id"
                                    isCheckbox={true}
                                    rowClick={rowClickObjectives}
                                    reorderClick={reorderClick1}
                                />
                            </div>
                        </div>
                    </div>
                }
                {
                    _.find(props.clientPlanData.clientPlanTable, { table_name: "Client Key Issues" })?.status &&
                    <div className="col-md-6 pl-0 box-border-plan ml-10">
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col pr-0">
                                <div className="form-group row align-items-center mb-0">
                                    <div className="col-md-4 pl-0">
                                        {/* <p className="form-label text-left">
                                    </p> */}
                                    </div>
                                    <div className="col pr-0 d-flex justify-end">
                                        <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteIssues} />
                                        <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemIssues} />
                                    </div>
                                </div>
                                <DataTable
                                    value={clientPlan.client_key_issues}
                                    columns={columns3}
                                    dataKey="_id"
                                    isCheckbox={true}
                                    rowClick={rowClickIssues}
                                    reorderClick={reorderClick2}
                                />
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div className="new-field mt-20">
                {
                    _.find(props.clientPlanData.clientPlanTable, { table_name: "Document Reference" })?.status &&
                    <div className="form-group row mb-0 mt-0 box-border-plan">
                        <div className="col pr-0">
                            <div className="form-group row align-items-center mb-0">
                                <div className="col-md-4 pl-0">
                                    <p className="label-text">
                                        {clientDocumentHeading}
                                    </p>
                                </div>
                                <div className="col pr-0 d-flex justify-end">
                                    <ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteDocument} />
                                    <ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemDocument} />
                                </div>
                            </div>
                            <DataTable
                                value={clientPlan.document_reference}
                                columns={columns4}
                                dataKey="_id"
                                isCheckbox={true}
                                rowClick={rowClickDocument}
                                reorderClick={reorderClick3}
                            />
                        </div>
                    </div>
                }
                <div className="form-group row align-items-center mb-0 mt-20">
                    {
                        _.find(props.clientPlanData.clientFieldsClientPlan, { field_name: 'Our Response Target Strategies & Tactics' })?.field_status &&
                        <>
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left">{_.find(props.clientPlanData.clientFieldsClientPlan, { field_name: 'Our Response Target Strategies & Tactics' })?.display_name}:</label>
                            </div>
                            <div className="col-md-1 pl-0">
                                {
                                    customerData?.Stakeholder_plan?.our_response_target_strategies_tactics.status == true &&
                                    <div>
                                        <Tooltip target=".custom-target-icon" />

                                        <i className="custom-target-icon pi pi-info-circle tooltip-font"
                                            data-pr-tooltip={customerData?.Stakeholder_plan?.our_response_target_strategies_tactics.text}
                                            data-pr-position="right">
                                        </i>
                                    </div>
                                }
                            </div>
                            <div className='col pr-0'>
                                <MultiSelect
                                    value={selectedOne}
                                    options={multiHeader}
                                    onChange={onChangeMulti}
                                    optionLabel="label"
                                    optionGroupLabel="label"
                                    optionGroupChildren="items"
                                    optionGroupTemplate={groupedItemTemplate}
                                    placeholder="Select"
                                    display="chip"
                                    className="w-full md:w-20rem"
                                    maxSelectedLabels={1}
                                    showSelectAll={false}
                                />
                            </div>
                        </>
                    }
                </div>
                {
                    _.find(props.clientPlanData.clientPlanTable, { table_name: "Known Client Initiatives" })?.status &&
                    <>
                        <div className="form-group row align-items-center mb-0">
                            <div className="col-md-4 pl-0">
                                <p className="label-text">
                                    {clientKnownHeading}
                                </p>
                            </div>
                            <div className="col pr-0 d-flex justify-end">
                                <ButtonElement icon="pi pi-filter-slash" className="edit-option-button font-text" onClick={resetButton} />
                                <div className='p-relative ml-10' ref={dropdownRef}>
                                    <ButtonElement className="edit-option-button" icon="pi pi-filter" onClick={toggleDropdown} />
                                    {showDropdown && (
                                        <>
                                            <div className='s-field'>
                                                <div className='new-field w-100'>
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">
                                                                Person Responsibile:
                                                            </label>
                                                        </div>
                                                        <div className="col pr-0">
                                                            <MultiSelectElement
                                                                value={selectedPersonResp}
                                                                optionLabel="label"
                                                                options={filterUsers || []}
                                                                placeholder="-- Please select --"
                                                                maxSelectedLabels={1}
                                                                onChangeValue={(e) => handleSelection(e.value)}
                                                                className="w-full"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row align-items-center mb-0 mt-0">
                                                        <div className="col-md-5 pl-0">
                                                            <label className="form-label text-left">
                                                                Status:
                                                            </label>
                                                        </div>
                                                        <div className="col pr-0">
                                                            <MultiSelectElement
                                                                value={selectedStatus}
                                                                optionLabel="label"
                                                                options={statusFilter}
                                                                placeholder="-- Please select --"
                                                                maxSelectedLabels={1}
                                                                onChangeValue={(e) => handleStatusSelection(e.value)}
                                                                className="w-full"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <ButtonElement className="edit-option-button ml-10" icon="pi pi-trash" onClick={removeSelected} />
                                <ButtonElement type="submit" className="edit-option-button ml-10" icon="pi pi-plus" onClick={addNewStrategy} />
                            </div>
                        </div>

                        <div className="group-table-data risks-tab">
                            <table className="group-datatable">
                                <thead className="group-table-header">
                                    <tr>
                                        <th className="checkbox-header"></th>
                                        <th className="w-40">{_.find(props.clientPlanData.clientKnownHeaders, { header_name: 'Strategic Initiative' })?.display_name}</th>
                                        <th className="w-20">{_.find(props.clientPlanData.clientKnownHeaders, { header_name: 'Person Responsible' })?.display_name}</th>
                                        <th className="w-20">{_.find(props.clientPlanData.clientKnownHeaders, { header_name: 'Target Date' })?.display_name}</th>
                                        <th className="w-20">{_.find(props.clientPlanData.clientKnownHeaders, { header_name: 'Completed' })?.display_name}</th>
                                    </tr>
                                </thead>
                                <tbody className="group-table-row stakeplan">
                                    {newArrayData && newArrayData?.map((section, ind) => {
                                        
                                        return (
                                            <React.Fragment key={section.strategies}>
                                                <tr>
                                                    <td className="group-header">
                                                        <CheckboxElement
                                                            id={`known-${ind}`}
                                                            name={`known-${ind}`}
                                                            value={false}
                                                            checked={false}
                                                            onChangeCheck={(e) => handleCheckboxChange(e, ind, section.strategies)}
                                                            className="mr-2"
                                                        />
                                                    </td>
                                                    <td className="w-40 group-header">
                                                        <InputTextElementElement
                                                            id="refField"
                                                            name="strategies"
                                                            defaultValue={section.strategies}
                                                            onChange={(e) => handleInputChange(e, ind, section.strategies)}
                                                            required
                                                            className="w-full font-bold"
                                                        />
                                                    </td>
                                                    <td className="w-20 group-header"></td>
                                                    <td className="w-20 group-header"></td>
                                                    <td className="w-20 group-header"></td>
                                                </tr>
                                                {section?.strategic_initiative?.map((item, index) => (
                                                    <tr key={`${section.strategies}-${index}`}>
                                                        <td>
                                                            <CheckboxElement
                                                                id={`known-${index}`}
                                                                name={`known-${index}`}
                                                                value={false}
                                                                checked={false}
                                                                onChangeCheck={(e) => { handleSelectedSubStretigies(e.target.checked, item, section.strategies); setKnownChecked1(e.target.checked, item); }}
                                                                className="mr-2"
                                                            />
                                                        </td>
                                                        <td className="w-40">
                                                            <InputTextElementElement
                                                                id="refField"
                                                                name="strategic_initiative_name"
                                                                value={item.strategic_initiative_name}
                                                                onChange={(e) => handleInputChangeName(e, ind, index)}
                                                                required
                                                                className="w-full"
                                                            />
                                                        </td>
                                                        <td className="w-20">
                                                            <SingleSelectElement
                                                                id='user'
                                                                name="user"
                                                                options={(userDataOps != undefined && userDataOps.length > 0) ? userDataOps : []}
                                                                optionLabel="label"
                                                                value={item.person_responsible}
                                                                onChangeValue={(e) => handlePerson(e, ind, index)}
                                                                placeholder="-- Please select --"
                                                                maxSelectedLabels={1}
                                                                className="w-150"
                                                            />
                                                        </td>
                                                        <td className="w-20">
                                                            <CalendarElement
                                                                id="multiple"
                                                                placeholder="Choose a date"
                                                                value={convertDateStringToFormattedString(item.target_date)}
                                                                onChange={(e) => handleDate(e, ind, index)}
                                                                readOnlyInput
                                                            />
                                                        </td>
                                                        <td className="w-20">
                                                            <CheckboxElement
                                                                id="completed"
                                                                name="completed"
                                                                checked={item.isCompleted}
                                                                onChangeCheck={(e) => handleCompleted(e, ind, index, section.strategies, item)}
                                                                className="mr-2"
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </>
                }
                {
                    checked &&
                    <div className="form-group row align-items-center mb-0 mt-0">
                        <div className='col pr-0'>
                            <label className="form-label text-left font-bold">{checkedData.strategy + ': '}</label> &nbsp;
                            <label className="form-label text-left">{checkedData.name}</label>
                            <TextareaElement
                                name="myTextarea"
                                defaultValue={checkedData.initiative_description}
                                rows={4}
                                cols={30}
                                placeholder="Enter text here..."
                                className="w-full"
                                disabled={false}
                                onChange={(e) => handleTextInitiativesName(e, checkedData.strategy, checkedData.name)}
                            />
                        </div>
                    </div>
                }
                {
                    customerShort && (customerShort !== process.env.REACT_APP_JMAN && customerShort !== process.env.REACT_APP_BAXALL) && <div className="cancel-footer mt-20">
                    <div className='d-flex align-center justify-end pb-0'>
                        <ButtonElement className="save-button" type="submit" label="Generate Relationship Manager Report" onClick={generateCPlans} />
                    </div>
                </div>
                }
                
            </div>
            <Dialog
                header={headerTemplate}
                visible={clientInitiativesCompletedModal}
                position="right"
                onHide={() => closeClientCompleted()}
                draggable={false}
                resizable={false}
                footer={renderFooter()}
                className="table-dialog width-32"
            >
                <>
                    {
                        isUserActionOwnerSameTarget ? <div className="confirmation-content">
                            <span className="table-description">
                                Do you want to complete this action?
                            </span>
                        </div> :
                            <div className="confirmation-content">
                                <span className="table-description">
                                    This action belongs to another user. Your are not authorised to complete this action.
                                </span>
                            </div>

                    }
                </>
            </Dialog>

            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_STAKEHOLDERS_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="stakeholders_plan" />
                    </div>
                </div>
            </Dialog>

        </div>
    )
}